// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-page {

    padding: 30px 20px;
    background: var(--bg-100);
    padding-bottom: 80px;
    max-width: 600px;
    margin: auto;

}

.network-header {

    margin-bottom: 20px;

}

.network-header h1 {

    margin: 0;
    font-size: 22px;
    font-weight: 700;
    color: var(--primary-100);

}

.network-section {

    margin-top: 30px;

}

.network-grid {

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;

}

.network-header p {
    color: var(--text-200);
    margin-top: 20px;
    font-size: 14px;
}

.network-skeleton {

    height: 200px;
    background: #eee;
    border-radius: 10px;

}


.network-row {

    display: flex;

    gap: 16px;

    overflow-x: auto;

    padding-bottom: 10px;

    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;

}

.network-row::-webkit-scrollbar {
    display: none;
}

.network-card {

    min-width: 320px;
    max-width: 320px;

    min-height: 280px;

    flex-shrink: 0;

}

.network-skeleton {

    min-width: 220px;
    height: 220px;

    border-radius: 10px;

    background: #eee;

}


.network-section h2 {
    margin-bottom: 15px;
}

/* CarrerUp network command deck. */
.network-page {
    box-sizing: border-box;
    width: min(1240px, calc(100% - 48px));
    max-width: none;
    min-height: calc(100vh - 64px);
    margin: 0 auto;
    padding: 24px 0 58px;
    color: #1d394f;
    background: transparent;
    font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.network-header {
    position: relative;
    margin: 0 0 18px;
    padding: 25px 26px;
    overflow: hidden;
    /* border: 1px solid rgba(78, 119, 153, .17); */
    border-radius: 20px;
    background: #fbfcfd;
    box-shadow: 0 15px 35px rgba(30, 63, 88, .08), inset 0 1px #ffffff;
}

.network-header::before {
    content: "";
    position: absolute;
    top: 0;
    right: 28px;
    left: 28px;
    height: 3px;
    border-radius: 0 0 4px 4px;
    background: #e95a13;
}

.network-header h1 {
    margin: 0;
    color: #1d394f;
    font-family: inherit;
    font-size: 1.28rem;
    font-weight: 850;
    letter-spacing: -.025em;
}

.network-header p {
    max-width: 650px;
    margin: 7px 0 0;
    color: #71899b;
    font-family: inherit;
    font-size: .84rem;
    font-weight: 550;
    line-height: 1.55;
}

.network-section { margin-top: 0; }
.network-section h2 {
    margin: 0 0 13px;
    padding: 0 2px;
    color: #29475e;
    font-family: inherit;
    font-size: 1.04rem;
    font-weight: 850;
    letter-spacing: -.015em;
}

.network-row {
    gap: 13px;
    padding: 2px 2px 15px;
    scroll-padding-left: 2px;
    scrollbar-width: thin;
    scrollbar-color: #94a9ba transparent;
}

.network-row::-webkit-scrollbar { display: block; height: 5px; }
.network-row::-webkit-scrollbar-thumb { border-radius: 999px; background: #94a9ba; }

.network-row .network-card {
    min-width: 252px;
    max-width: 252px;
    min-height: 236px;
}

.network-skeleton {
    min-width: 252px;
    height: 236px;
    border: 1px solid rgba(78, 119, 153, .14);
    border-radius: 17px;
    background: #e5edf1;
    animation: network-skeleton-pulse 1.2s ease-in-out infinite alternate;
}

@keyframes network-skeleton-pulse { from { opacity: .55; } to { opacity: 1; } }

@media (max-width: 768px) {
    .network-page { width: 100%; min-height: 0; padding: 14px 12px 88px; }
    .network-header { margin: 7px -12px 14px; padding: 24px 26px; border-radius: 0 0 17px 17px; }
    .network-header::before { right: 18px; left: 18px; }
    .network-header h1 { font-size: 1.1rem; }
    .network-header p { font-size: .76rem; }
    .network-section h2 { font-size: .94rem; }
    .network-row { gap: 10px; padding: 1px 0 12px; }
    .network-row .network-card, .network-skeleton { min-width: min(252px, calc(100vw - 44px)); max-width: min(252px, calc(100vw - 44px)); }
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/Reseau.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;;AAEhB;;AAEA;;IAEI,mBAAmB;;AAEvB;;AAEA;;IAEI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;;IAEI,gBAAgB;;AAEpB;;AAEA;;IAEI,aAAa;IACb,4DAA4D;IAC5D,SAAS;;AAEb;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;;AAEvB;;;AAGA;;IAEI,aAAa;;IAEb,SAAS;;IAET,gBAAgB;;IAEhB,oBAAoB;;IAEpB,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;;IAEhB,iBAAiB;;IAEjB,cAAc;;AAElB;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;;IAEb,mBAAmB;;IAEnB,gBAAgB;;AAEpB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA,mCAAmC;AACnC;IACI,sBAAsB;IACtB,qCAAqC;IACrC,eAAe;IACf,8BAA8B;IAC9B,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,uBAAuB;IACvB,oEAAoE;AACxE;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;IAC/C,mBAAmB;IACnB,mBAAmB;IACnB,kEAAkE;AACtE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,mBAAmB,aAAa,EAAE;AAClC;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA,kCAAkC,cAAc,EAAE,WAAW,EAAE;AAC/D,wCAAwC,oBAAoB,EAAE,mBAAmB,EAAE;;AAEnF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,qEAAqE;AACzE;;AAEA,oCAAoC,OAAO,YAAY,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE9E;IACI,gBAAgB,WAAW,EAAE,aAAa,EAAE,uBAAuB,EAAE;IACrE,kBAAkB,sBAAsB,EAAE,kBAAkB,EAAE,4BAA4B,EAAE;IAC5F,0BAA0B,WAAW,EAAE,UAAU,EAAE;IACnD,qBAAqB,iBAAiB,EAAE;IACxC,oBAAoB,iBAAiB,EAAE;IACvC,sBAAsB,iBAAiB,EAAE;IACzC,eAAe,SAAS,EAAE,mBAAmB,EAAE;IAC/C,gDAAgD,yCAAyC,EAAE,yCAAyC,EAAE;AAC1I","sourcesContent":[".network-page {\n\n    padding: 30px 20px;\n    background: var(--bg-100);\n    padding-bottom: 80px;\n    max-width: 600px;\n    margin: auto;\n\n}\n\n.network-header {\n\n    margin-bottom: 20px;\n\n}\n\n.network-header h1 {\n\n    margin: 0;\n    font-size: 22px;\n    font-weight: 700;\n    color: var(--primary-100);\n\n}\n\n.network-section {\n\n    margin-top: 30px;\n\n}\n\n.network-grid {\n\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 20px;\n\n}\n\n.network-header p {\n    color: var(--text-200);\n    margin-top: 20px;\n    font-size: 14px;\n}\n\n.network-skeleton {\n\n    height: 200px;\n    background: #eee;\n    border-radius: 10px;\n\n}\n\n\n.network-row {\n\n    display: flex;\n\n    gap: 16px;\n\n    overflow-x: auto;\n\n    padding-bottom: 10px;\n\n    scroll-behavior: smooth;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n}\n\n.network-row::-webkit-scrollbar {\n    display: none;\n}\n\n.network-card {\n\n    min-width: 320px;\n    max-width: 320px;\n\n    min-height: 280px;\n\n    flex-shrink: 0;\n\n}\n\n.network-skeleton {\n\n    min-width: 220px;\n    height: 220px;\n\n    border-radius: 10px;\n\n    background: #eee;\n\n}\n\n\n.network-section h2 {\n    margin-bottom: 15px;\n}\n\n/* CarrerUp network command deck. */\n.network-page {\n    box-sizing: border-box;\n    width: min(1240px, calc(100% - 48px));\n    max-width: none;\n    min-height: calc(100vh - 64px);\n    margin: 0 auto;\n    padding: 24px 0 58px;\n    color: #1d394f;\n    background: transparent;\n    font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.network-header {\n    position: relative;\n    margin: 0 0 18px;\n    padding: 25px 26px;\n    overflow: hidden;\n    /* border: 1px solid rgba(78, 119, 153, .17); */\n    border-radius: 20px;\n    background: #fbfcfd;\n    box-shadow: 0 15px 35px rgba(30, 63, 88, .08), inset 0 1px #ffffff;\n}\n\n.network-header::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: 28px;\n    left: 28px;\n    height: 3px;\n    border-radius: 0 0 4px 4px;\n    background: #e95a13;\n}\n\n.network-header h1 {\n    margin: 0;\n    color: #1d394f;\n    font-family: inherit;\n    font-size: 1.28rem;\n    font-weight: 850;\n    letter-spacing: -.025em;\n}\n\n.network-header p {\n    max-width: 650px;\n    margin: 7px 0 0;\n    color: #71899b;\n    font-family: inherit;\n    font-size: .84rem;\n    font-weight: 550;\n    line-height: 1.55;\n}\n\n.network-section { margin-top: 0; }\n.network-section h2 {\n    margin: 0 0 13px;\n    padding: 0 2px;\n    color: #29475e;\n    font-family: inherit;\n    font-size: 1.04rem;\n    font-weight: 850;\n    letter-spacing: -.015em;\n}\n\n.network-row {\n    gap: 13px;\n    padding: 2px 2px 15px;\n    scroll-padding-left: 2px;\n    scrollbar-width: thin;\n    scrollbar-color: #94a9ba transparent;\n}\n\n.network-row::-webkit-scrollbar { display: block; height: 5px; }\n.network-row::-webkit-scrollbar-thumb { border-radius: 999px; background: #94a9ba; }\n\n.network-row .network-card {\n    min-width: 252px;\n    max-width: 252px;\n    min-height: 236px;\n}\n\n.network-skeleton {\n    min-width: 252px;\n    height: 236px;\n    border: 1px solid rgba(78, 119, 153, .14);\n    border-radius: 17px;\n    background: #e5edf1;\n    animation: network-skeleton-pulse 1.2s ease-in-out infinite alternate;\n}\n\n@keyframes network-skeleton-pulse { from { opacity: .55; } to { opacity: 1; } }\n\n@media (max-width: 768px) {\n    .network-page { width: 100%; min-height: 0; padding: 14px 12px 88px; }\n    .network-header { margin: 7px -12px 14px; padding: 24px 26px; border-radius: 0 0 17px 17px; }\n    .network-header::before { right: 18px; left: 18px; }\n    .network-header h1 { font-size: 1.1rem; }\n    .network-header p { font-size: .76rem; }\n    .network-section h2 { font-size: .94rem; }\n    .network-row { gap: 10px; padding: 1px 0 12px; }\n    .network-row .network-card, .network-skeleton { min-width: min(252px, calc(100vw - 44px)); max-width: min(252px, calc(100vw - 44px)); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
